import { createStore, createHook, createContainer, createActionsHook } from 'react-sweet-state';

type State = { confettiColumns: Set<number> };

const actions = {
	addConfettiColumn:
		(columnId: number) =>
		({ setState, getState }: { setState: (arg1: State) => void; getState: () => State }) => {
			const currentState = getState();
			const confettiColumns = new Set(currentState.confettiColumns);
			confettiColumns.add(columnId);
			setState({ confettiColumns });
		},
	removeConfettiColumn:
		(columnId: number) =>
		({ setState, getState }: { setState: (arg1: State) => void; getState: () => State }) => {
			const currentState = getState();
			const confettiColumns = new Set(currentState.confettiColumns);
			confettiColumns.delete(columnId);
			setState({ confettiColumns });
		},
};

type Actions = typeof actions;

/** @deprecated Remove when jwm.board-awesome-enhancements is cleaned up */
export const ConfettiColumnsContainer = createContainer();

const store = createStore<State, Actions>({
	containedBy: ConfettiColumnsContainer,
	initialState: { confettiColumns: new Set() },
	actions,
	name: 'JWMConfettiColumnsStore',
});

/** @deprecated Remove when jwm.board-awesome-enhancements is cleaned up */
export const useConfettiColumns = createHook(store);

/** @deprecated Remove when jwm.board-awesome-enhancements is cleaned up */
export const useConfettiColumnActions = createActionsHook(store);
